<template>
  <div class="checkboxes">
    <CheckboxItem
      v-for="o in normalized"
      :key="o.value"
      :id="`cb-${o.value}`"
      :label="o.label"
      :value="o.value"
      :right-display-info="o.rightDisplayInfo"
      :detailed-info="o.detailedInfo"
      :expandable="o.expandable"
      :checked="selectedSet.has(o.value)"
      @toggle="toggle"
      >
      <template #details="slotProps">
        <slot name="details" v-bind="slotProps" />
      </template>
    </CheckboxItem>
  </div>
</template>

<script>
import CheckboxItem from './CheckboxItem.vue';

export default {
  name: 'Checkboxes',
  components: { CheckboxItem },
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Array, default: () => [] },      // array of selected values
    options: { type: Array, default: () => [] },    // flexible schema
    valueKey: { type: String, default: 'value' },
    labelKey: { type: String, default: 'label' },
    rightDisplayKey: { type: String, default: 'right_display_info' },
    detailedInfoKey: { type: String, default: 'detailed_info' },
    expandableKey: { type: String, default: 'expandable' },
  },
  computed: {
    selectedSet() { return new Set(this.value || []); },
    normalized() {
      return (this.options || []).map(o => {
        const label = o[this.labelKey];
        const value = String(o[this.valueKey]);
        const detailedInfo = o[this.detailedInfoKey];
        const rightDisplayInfo = o[this.rightDisplayKey];
        const hasDetails = Array.isArray(detailedInfo) ? detailedInfo.length > 0 : !!detailedInfo;
        const expandable = this.expandableKey in o ? !!o[this.expandableKey] : hasDetails;
        return { label, value, detailedInfo, rightDisplayInfo, expandable };
      });
    },
  },
  methods: {
    toggle(val) {
      const arr = this.value ? this.value.slice() : [];
      const i = arr.indexOf(val);
      if (i >= 0) arr.splice(i, 1);
      else arr.push(val);
      this.$emit('input', arr);
    },
  },
};
</script>

<style scoped>
.checkboxes {
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  background: transparent;
  border: 0;
}
</style>
